import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import rootFolderIcon from "../../assets/rootfolder.svg";
import subfolderIcon from "../../assets/subfolder.svg";
import versionIcon from "../../assets/versionIconRound.svg";
import { ReactComponent as VerticalDots } from "../../assets/verticalDotsColor.svg";
import arrowDown from "../../assets/arrowDown.svg";
import "./ProjectExplorer.css";
import { useDispatch, useSelector } from "react-redux";
import {
  currentProjectsStructureSelector,
  orgTariffesSelector,
  projectsArchivedSelector,
  projectsSelector,
  sharedProjectsSelector,
  sharedProjectsStructureSelector,
  userSelector,
} from "../../store/selectors";
import ProjectContextMenu from "../ProjectContextMenu/ProjectContextMenu";
import VersionContextMenu from "../VersionContextMenu/VersionContextMenu";
import {
  deleteProject,
  deleteProjectRole,
  deleteVersion,
  explorerProjectUpdated,
  explorerVersionUpdated,
  fetchProjectById,
  fetchProjectByIdForExplorer,
  fetchProjects,
  fetchSharedProjects,
  forceDeleteProject,
  forceDeleteVersion,
  removeOrganizationFromStructure,
  removeUserFromProject,
  resetProjectsExplorer,
  switchProjectUnfold,
  switchSharedProjectUnfold,
  updateProjectArchiveStatus,
  updateVersionArchiveStatus,
} from "../../store/projectsSlice";
import { ReactComponent as StarIcon } from "../../assets/starIconPurple.svg";
import { setIsAppLoading } from "../../store/appSlice";
import EditProjectModal from "../EditProjectModal/EditProjectModal";
import EditProjectPosterModal from "../EditProjectPosterModal/EditProjectPosterModal";
import EditVersionModal from "../EditVersionModal/EditVersionModal";
import { OrbitProgress } from "react-loading-indicators";
import EditOrganizationModal from "../EditOrganizationModal/EditOrganizationModal";
import OrganizationItemContextMenu from "../OrganizationContextMenu/OrganizationItemContextMenu";
import {
  deleteOrganization,
  deleteUserFromOrganizationAndProject,
  deleteUserProjectRole,
  fetchUserProjectRoles,
} from "../../store/usersSlice";
import { escape } from "lodash";
import InfoModal from "../InfoModal/InfoModal";
import toast from "react-hot-toast";
import ShareModal from "../ShareModal/ShareModal";
import useOrganizationRole from "../../hooks/useOrganizationRole";
import OrgUsersPopup from "../VideoPage/OrgUsersPopup";

function ProjectExplorer({
  isShared = false,
  isViewer = false,
  currentProject,
  limits,
  currentOrganization,
  isOrgPopupOpen,
  isMobile,
  onOrganizationClick,
  organizations,
  projectUsers,
  onOrganizationSelect,
  onAddOrganization,
  isPageLoading = false,
  showArchived = false,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentProjectsStructure = useSelector(
    currentProjectsStructureSelector
  );
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [showProjectContextMenu, setShowProjectContextMenu] = useState(false);
  const [showVersionContextMenu, setShowVersionContextMenu] = useState(false);
  const [titleHovered, setTitleHovered] = useState(false);
  const [showOrgItemContextMenu, setShowOrgItemContextMenu] = useState(false);
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [hoveredDotsItemId, setHoveredDotsItemId] = useState(null);
  const user = useSelector(userSelector);
  const [organizationToRename, setOrganizationToRename] = useState(null);
  const [orgToShowUsersPopup, setOrgToShowUsersPopup] = useState(false);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const contextMenuRef = useRef(null);
  const projectContextMenuRef = useRef(null);
  const versionContextMenuRef = useRef(null);
  const orgItemContextMenuRef = useRef(null);
  const dropdownRef = useRef(null);
  const dotsRef = useRef(null);
  const [projectToRename, setProjectToRename] = useState(null);
  const [projectToChangeCover, setProjectToChangeCover] = useState(null);
  const [versionToRename, setVersionToRename] = useState(null);
  const currentprojectsArray = useSelector(projectsSelector);
  const archivedProjectsArray = useSelector(projectsArchivedSelector);
  const sharedProjectsArray = useSelector(sharedProjectsSelector);
  const sharedProjectsStructure = useSelector(sharedProjectsStructureSelector);
  const organizationsTariffes = useSelector(orgTariffesSelector);
  const projectsArray = currentprojectsArray;
  const [isOrganizationLimitModalVisible, setIsOrganizationLimitModalVisible] =
    useState(false);
  const [shareModalEntity, setShareModalEntity] = useState(null);
  const myOrgRole = useOrganizationRole();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showContextMenu &&
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dotsRef.current &&
        !dotsRef.current.contains(event.target)
      ) {
        setShowContextMenu(false);
      }

      if (
        showOrgItemContextMenu &&
        orgItemContextMenuRef.current &&
        !orgItemContextMenuRef.current.contains(event.target)
      ) {
        setShowOrgItemContextMenu(false);
      }

      if (
        showProjectContextMenu &&
        projectContextMenuRef.current &&
        !projectContextMenuRef.current.contains(event.target)
        // dropdownRef.current &&
        // !dropdownRef.current.contains(event.target) &&
        // dotsRef.current &&
        // !dotsRef.current.contains(event.target)
      ) {
        setShowProjectContextMenu(false);
        setSelectedItem(null);
      }

      if (
        showVersionContextMenu &&
        versionContextMenuRef.current &&
        !versionContextMenuRef.current.contains(event.target)
      ) {
        setShowVersionContextMenu(false);
        setSelectedItem(null);
      }

      setHoveredDotsItemId(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    showContextMenu,
    showProjectContextMenu,
    showVersionContextMenu,
    showOrgItemContextMenu,
  ]);

  const onClickExplorerDots = (explorerItem, event) => {
    if (isShared) return;
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();
    setContextMenuPosition({
      top: rect.bottom + window.scrollY,
      left: rect.right + window.scrollX - 224,
    });
    setSelectedItem(explorerItem);

    if (explorerItem.isOrg) {
      setShowProjectContextMenu(false);
      setShowVersionContextMenu(false);
      setShowOrgItemContextMenu(true);
    } else if (explorerItem.isFolder) {
      // It's a version
      setShowVersionContextMenu(false);
      setShowProjectContextMenu(true);
      setShowOrgItemContextMenu(false);
    } else {
      // It's a version
      setShowVersionContextMenu(true);
      setShowProjectContextMenu(false);
      setShowOrgItemContextMenu(false);
    }
  };

  const onPressOrganization = (orgId) => {
    const selectedOrg = organizations.find((org) => org.id === orgId);
    onOrganizationSelect(selectedOrg);
  };

  const handleContextMenuAction = (action) => {
    // This will be implemented later
    setShowProjectContextMenu(false);
  };

  const handleRemoveProjectFromShared = (event, item) => {
    event.preventDefault();
    event.stopPropagation();
    if (confirm("Вы действительно хотите удалить проект из доступных?")) {
      let roleId = item.myRole && item.myRole.id;
      if (!roleId && projectUsers) {
        const existingRole = projectUsers.find(
          (role) => role.userId === user.userId
        );
        if (existingRole) {
          roleId = existingRole.id;
        }
      }
      dispatch(deleteProjectRole(roleId)).then((res) => {
        if (!res.error) {
          dispatch(
            fetchSharedProjects({
              organizationId: currentOrganization.id,
              isDeleted: false,
            })
          );
        }
      });
      // dispatch(
      //   removeUserFromProject({
      //     projectId,
      //     userId: user.userId,
      //   })
      // ).then((res) => {
      //   if (!res.error) {
      //   }
      // });
    }
  };

  const fetchCurrentProjects = (withReset = false, goHome = false) => {
    dispatch(
      fetchProjects({
        organizationId: currentOrganization.id,
        isDeleted: false,
      })
    ).then((res) => {
      if (!res.error) {
        dispatch(setIsAppLoading(false));
        if (withReset) {
          dispatch(resetProjectsExplorer());
        }
        if (goHome) {
          navigate("/home");
        }
      }
    });
    dispatch(
      fetchSharedProjects({
        organizationId: currentOrganization.id,
        isDeleted: false,
      })
    );
  };

  const handleArchiveProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowProjectContextMenu(false);
    const savedCurrentProject = currentProject;
    if (window.confirm(t("projectScreen.confirmArchive"))) {
      dispatch(
        updateProjectArchiveStatus({ projectId, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Проект перемещен в архив");
          removeProjectInProjectsStructure(projectId, savedCurrentProject);
        }
      });
    }
  };

  const handleDeleteProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowProjectContextMenu(false);
    const savedCurrentProject = currentProject;
    if (window.confirm(t("projectScreen.confirmDelete"))) {
      dispatch(forceDeleteProject(projectId)).then((res) => {
        if (!res.error) {
          toast.success("Проект удален");
          removeProjectInProjectsStructure(projectId, savedCurrentProject);
        }
      });
    }
  };

  const handleRenameProject = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    setShowProjectContextMenu(false);
    const project = selectedItem;
    setProjectToRename(project);
  };

  const handleChangeCover = (event, projectId) => {
    console.log(event, projectId, projectsArray, currentProject);
    event.preventDefault();
    event.stopPropagation();
    setShowProjectContextMenu(false);
    let project = projectsArray.find((p) => p.id === projectId);
    console.log(project);
    if (projectId === currentProject.id) {
      project = currentProject;
    }
    if (!project && currentProject) {
      project = currentProject.subprojects.find((sub) => sub.id === projectId);
    }
    setProjectToChangeCover(project);
  };

  const handleRenameVersion = (event, versionId) => {
    event.preventDefault();
    event.stopPropagation();
    setShowVersionContextMenu(false);
    const version = selectedItem;
    setVersionToRename(version);
  };

  const handleArchiveVersion = (event, versionId) => {
    event.preventDefault();
    event.stopPropagation();
    setShowVersionContextMenu(false);
    if (window.confirm(t("projectScreen.confirmArchiveVersion"))) {
      dispatch(
        updateVersionArchiveStatus({ versionId, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Версия перемещена в архив");
          removeVersionInProjectsStructure(versionId);
        }
      });
    }
  };

  const handleDeleteVersion = (event, versionId) => {
    event.preventDefault();
    event.stopPropagation();
    setShowVersionContextMenu(false);
    if (window.confirm(t("projectScreen.confirmDeleteVersion"))) {
      dispatch(forceDeleteVersion(versionId)).then((res) => {
        if (!res.error) {
          toast.success("Версия удалена");
          removeVersionInProjectsStructure(versionId);
        }
      });
    }
  };

  const fetchCurrentProjectById = (projectId) => {
    dispatch(fetchProjectByIdForExplorer({ projectId }));
  };

  const findProjectIdToUpdate = (
    objectToSearch,
    pathToCheck,
    versionIdToFind
  ) => {
    if (!pathToCheck.length) {
      return null;
    }
    const currentlyCheckingEntryId = pathToCheck[0].id;
    const currentlyCheckingEntry =
      objectToSearch[currentlyCheckingEntryId].children;
    if (!!currentlyCheckingEntry[versionIdToFind]) {
      return currentlyCheckingEntryId;
    } else {
      const nextPath = pathToCheck.slice(1);
      return findProjectIdToUpdate(
        currentlyCheckingEntry,
        nextPath,
        versionIdToFind
      );
    }
  };

  const getVersionPathToUpdate = (
    objectToSearch,
    pathToCheck,
    versionIdToFind,
    result
  ) => {
    if (!pathToCheck.length) {
      return null;
    }
    const currentlyCheckingEntryId = pathToCheck[0].id;
    const currentlyCheckingEntry =
      objectToSearch[currentlyCheckingEntryId].children;
    if (!!currentlyCheckingEntry[versionIdToFind]) {
      return result + ".children." + versionIdToFind;
    } else {
      const nextPath = pathToCheck.slice(1);
      return getVersionPathToUpdate(
        currentlyCheckingEntry,
        nextPath,
        versionIdToFind,
        result + ".children." + nextPath[0].id
      );
    }
  };

  const removeVersionInProjectsStructure = async (versionId) => {
    const currentPath = (currentProject && currentProject.path) || [];
    // const rootProject = currentProjectsStructure[currentPath[0].id];
    const rootProject =
      currentProjectsStructure[currentOrganization.id].children[
        currentPath[0].id
      ];
    let neededPath = getVersionPathToUpdate(
      currentProjectsStructure[currentOrganization.id].children,
      currentPath,
      versionId,
      `${rootProject.id}`
    );
    dispatch(explorerVersionUpdated(neededPath, true, { id: versionId }));
  };

  const updateVersionInProjectsStructure = async (updatedVersion) => {
    const currentPath = (currentProject && currentProject.path) || [];
    const rootProject =
      currentProjectsStructure[currentOrganization.id].children[
        currentPath[0].id
      ];
    let neededPath = getVersionPathToUpdate(
      currentProjectsStructure[currentOrganization.id].children,
      currentPath,
      updatedVersion.id,
      `${rootProject.id}`
    );
    dispatch(explorerVersionUpdated(neededPath, false, updatedVersion));
  };

  const updateProjectInProjectsStructure = async (updatedProject) => {
    const currentPath = (updatedProject && updatedProject.path) || [];
    let neededPath;
    if (
      !!currentProjectsStructure[currentOrganization.id].children[
        updatedProject.id
      ]
    ) {
      neededPath = `${updatedProject.id}`;
    } else {
      const rootProject =
        currentProjectsStructure[currentOrganization.id].children[
          currentPath[0].id
        ];
      neededPath = getVersionPathToUpdate(
        currentProjectsStructure[currentOrganization.id].children,
        currentPath,
        updatedProject.id,
        `${rootProject.id}`
      );
    }

    dispatch(explorerProjectUpdated(neededPath, false, updatedProject));
  };

  const removeProjectInProjectsStructure = async (
    projectId,
    savedCurrentProject
  ) => {
    const currentPath = (currentProject && currentProject.path) || [];
    let neededPath;
    if (
      !!currentProjectsStructure[currentOrganization.id].children[projectId]
    ) {
      neededPath = `${projectId}`;
    } else {
      const rootProject =
        currentProjectsStructure[currentOrganization.id].children[
          currentPath[0].id
        ];
      neededPath = getVersionPathToUpdate(
        currentProjectsStructure[currentOrganization.id].children,
        currentPath,
        projectId,
        `${rootProject.id}`
      );
    }

    dispatch(explorerProjectUpdated(neededPath, true, { id: projectId }));
    checkIfNeedToRedirect(neededPath, projectId);
  };

  const checkIfNeedToRedirect = (deletedPath, deletedProjectId) => {
    if (!currentProject) return;
    const currentProjectDeletedParentIndex = currentProject.path.findIndex(
      (entry) => entry.id === deletedProjectId
    );
    if (currentProjectDeletedParentIndex > -1) {
      if (currentProjectDeletedParentIndex === 0) {
        navigate("/home");
      } else {
        const destinationProjectId =
          currentProject.path[currentProjectDeletedParentIndex - 1].id;
        navigate(`/projects/${destinationProjectId}`);
      }
    }
  };

  const renderSharedExplorerItem = (
    explorerItem,
    activePadding = 12,
    isLastChild
  ) => {
    const isVersion = !explorerItem.isFolder;
    const isRoot = explorerItem.isRoot;
    const isSubfolder = !explorerItem.isRoot && !isVersion;

    const isCurrentFolder =
      (currentProject && explorerItem.id === currentProject.id) ||
      (currentProject &&
        currentProject.versions.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1) ||
      (currentProject &&
        currentProject.subprojects.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1);

    const isCurrentProject =
      currentProject && explorerItem.id === currentProject.id;

    const isCurrentPath =
      currentProject &&
      currentProject.path.findIndex(
        (pathEntry) => pathEntry.id === explorerItem.id
      ) !== -1;

    const isCurrentRoot = explorerItem.isRoot && isCurrentPath;
    const isHovered = hoveredItemId === explorerItem.id;

    return (
      <>
        <div
          key={explorerItem.id}
          className="projectExplorer-project-item"
          onClick={() => {
            dispatch(resetProjectsExplorer());
            if (isCurrentProject) {
              dispatch(
                switchSharedProjectUnfold(
                  explorerItem.id,
                  !explorerItem.isUnfolded,
                  (currentProject && currentProject.path) || ""
                )
              );
              return;
            }
            if (isVersion) {
              if (isShared && isViewer) {
                navigate(`/video/${explorerItem.id}?shared=1&role=viewer`);
              } else if (isShared && !isViewer) {
                navigate(`/video/${explorerItem.id}?shared=1`);
              } else {
                navigate(`/video/${explorerItem.id}`);
              }
            } else {
              if (isViewer) {
                navigate(`/projects/${explorerItem.id}?shared=1&role=viewer`, {
                  state: {
                    isFromPage: true,
                  },
                });
              } else {
                navigate(`/projects/${explorerItem.id}?shared=1`, {
                  state: {
                    isFromPage: true,
                  },
                });
              }
            }
          }}
          onMouseEnter={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            setHoveredItemId(explorerItem.id)
          }
          onMouseLeave={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            setHoveredItemId(null)
          }
          style={{
            cursor: "pointer",
            paddingLeft: activePadding,
            position: "relative",
            marginBottom: isLastChild ? 0 : 4,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 6,
              height: 6,
              position: "absolute",
              left: -8 + activePadding,
            }}
          >
            {!isVersion && (
              <img
                src={arrowDown}
                alt="arrow"
                style={{
                  width: 6,
                  height: 6,
                  transform:
                    !isCurrentPath || !explorerItem.isUnfolded
                      ? "rotate(-90deg)"
                      : "rotate(0deg)",
                }}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: 5,
            }}
          >
            <img
              src={
                isSubfolder
                  ? subfolderIcon
                  : isVersion
                    ? versionIcon
                    : subfolderIcon
              }
              alt="arrow"
              style={
                isVersion
                  ? {
                      width: 16,
                      height: 16,
                    }
                  : {
                      width: 24,
                      height: 24,
                    }
              }
            />
          </div>
          <div
            style={{
              maxWidth: isHovered ? "85%" : "85%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              className="projectExplorer-project-item-title"
              style={{
                color: isVersion
                  ? "C1C7D4"
                  : isCurrentFolder
                    ? "#F1F7FF"
                    : "#C1C7D4",

                transition: "margin-right 0.1s ease",
                maxWidth: "100%",
                textOverflow: "ellipsis",
              }}
            >
              {explorerItem.title || explorerItem.version}
            </span>
          </div>
          {isHovered && isRoot && (
            <div
              onMouseEnter={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(explorerItem.id)
              }
              onMouseLeave={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(null)
              }
              ref={dotsRef}
              onClick={(e) => onClickExplorerDots(explorerItem, e)}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                padding: "4px",
              }}
            >
              <VerticalDots
                style={{
                  color:
                    selectedItem && selectedItem.id === explorerItem.id
                      ? "#3496FF"
                      : hoveredDotsItemId === explorerItem.id
                        ? "#C1C7D4"
                        : "#717B8E",
                }}
                width={16}
                height={16}
              />
            </div>
          )}
        </div>
        {((!explorerItem.isRoot || isCurrentRoot) &&
          explorerItem.children &&
          explorerItem.isUnfolded &&
          Object.keys(explorerItem.children).length !== 0 &&
          Object.values(explorerItem.children).map((child, index) =>
            renderSharedExplorerItem(
              child,
              activePadding + 17,
              index === Object.values(explorerItem.children).length - 1
            )
          )) ||
          null}
      </>
    );
  };

  const getOrgLimitsValues = (limitsArray) => {
    console.log(limitsArray);
    console.log(123);
    if (!limitsArray) return null;
    const usersLimitObject = limitsArray.find(
      (lim) => lim.attributeCode === "AVAILABLE_USER_COUNT"
    );
    const projectsLimitObject = limitsArray.find(
      (lim) => lim.attributeCode === "AVAILABLE_PROJECT_COUNT"
    );
    const spaceLimitObject = limitsArray.find(
      (lim) => lim.attributeCode === "AVAILABLE_SPACE_MB"
    );
    const usersCurrent = usersLimitObject?.usedValue || 0;
    const projectsCurrent = projectsLimitObject?.usedValue || 0;
    const spaceCurrent = spaceLimitObject?.usedValue || 0;
    const usersMax =
      usersLimitObject?.maxValue === -1 ? "∞" : usersLimitObject?.maxValue || 0;
    const projectsMax =
      projectsLimitObject?.maxValue === -1
        ? "∞"
        : projectsLimitObject?.maxValue || 0;
    const spaceMax =
      spaceLimitObject?.maxValue === -1 ? "∞" : spaceLimitObject?.maxValue || 0;

    return {
      usersLimit: usersLimitObject,
      projectsLimit: projectsLimitObject,
      spaceLimit: spaceLimitObject,
      usersCurrent,
      usersMax,
      projectsCurrent,
      projectsMax,
      spaceCurrent,
      spaceMax,
    };
  };

  const limitsValues = getOrgLimitsValues(limits);
  // const limitsValues = null;

  const renderExplorerItem = (
    explorerItem,
    activePadding = 12,
    isLastChild
  ) => {
    const isOrganization = !!explorerItem.isOrg;
    const isVersion = !explorerItem.isFolder;
    const isSubfolder = !explorerItem.isRoot && !isVersion;

    const isCurrentFolder =
      (currentProject && explorerItem.id === currentProject.id) ||
      (currentProject &&
        currentProject.versions.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1) ||
      (currentProject &&
        currentProject.subprojects.findIndex(
          (pathEntry) => pathEntry.id === explorerItem.id
        ) !== -1);

    const isCurrentProject =
      currentProject && explorerItem.id === currentProject.id;

    const isCurrentPath =
      currentProject &&
      currentProject.path.findIndex(
        (pathEntry) => pathEntry.id === explorerItem.id
      ) !== -1;

    const isCurrentRoot = explorerItem.isRoot && isCurrentPath;
    const isHovered = hoveredItemId === explorerItem.id;

    return (
      <>
        <div
          key={explorerItem.id}
          className="projectExplorer-project-item"
          onClick={() => {
            if (isOrganization) {
              onPressOrganization(explorerItem.id);
              return;
            }
            if (isCurrentProject) {
              dispatch(
                switchProjectUnfold(
                  explorerItem.id,
                  !explorerItem.isUnfolded,
                  (currentProject && currentProject.path) || ""
                )
              );
              return;
            }
            if (isVersion) {
              navigate(`/video/${explorerItem.id}`);
            } else {
              navigate(`/projects/${explorerItem.id}`, {
                state: {
                  isFromPage: true,
                },
              });
            }
          }}
          onMouseEnter={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            !isMobile &&
            setHoveredItemId(explorerItem.id)
          }
          onMouseLeave={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            !isMobile &&
            setHoveredItemId(null)
          }
          style={{
            cursor: "pointer",
            paddingLeft: activePadding,
            position: "relative",
            marginBottom: isOrganization || isLastChild ? 0 : isVersion ? 2 : 4,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 6,
              height: 6,
              position: "absolute",
              left: -8 + activePadding,
            }}
          >
            {isOrganization && (
              <StarIcon
                style={{
                  transform: "scale(3.7)",
                  fill: isHovered ? "#5CB1F6" : "#427FFF",
                }}
                width={24}
                height={24}
              />
            )}
            {!isVersion && !isOrganization && (
              <img
                src={arrowDown}
                alt="arrow"
                style={{
                  width: 6,
                  height: 6,
                  transform:
                    (!isCurrentPath && !isOrganization) ||
                    !explorerItem.isUnfolded
                      ? "rotate(-90deg)"
                      : "rotate(0deg)",
                }}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: isVersion ? 8 : 5,
            }}
          >
            {!isOrganization && (
              <img
                src={
                  isSubfolder
                    ? subfolderIcon
                    : isVersion
                      ? versionIcon
                      : subfolderIcon
                }
                alt="arrow"
                style={
                  isVersion
                    ? {
                        width: 18,
                        height: 18,
                      }
                    : {
                        width: 24,
                        height: 24,
                      }
                }
              />
            )}
          </div>
          <div
            style={{
              maxWidth: isHovered ? "75%" : "85%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {isOrganization ? (
              <span
                className="projectExplorer-project-item-title"
                style={{
                  backgroundImage: isHovered
                    ? "linear-gradient(#5CB1F6)"
                    : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  webkitBackgroundClip: "text",
                  color: "transparent",
                  // color: isHovered
                  //   ? "red"
                  //   : //: "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)"
                  //     "blue",
                  fontSize: isOrganization ? 15 : 14,
                  fontWeight: isOrganization ? 600 : 500,
                  transition: "margin-right 0.1s ease",
                  maxWidth: "100%",
                  textOverflow: "ellipsis",
                  marginLeft: isVersion ? 7 : 3,
                }}
              >
                {explorerItem.title}
              </span>
            ) : (
              <span
                className="projectExplorer-project-item-title"
                style={{
                  color: isVersion
                    ? "C1C7D4"
                    : isCurrentFolder
                      ? "#F1F7FF"
                      : "#C1C7D4",
                  fontSize: isOrganization ? 15 : 14,
                  fontWeight: isOrganization ? 600 : 500,
                  transition: "margin-right 0.1s ease",
                  maxWidth: "100%",
                  textOverflow: "ellipsis",
                  marginLeft: isVersion ? 7 : 3,
                }}
              >
                {explorerItem.title || explorerItem.version}
              </span>
            )}
            {isOrganization &&
            organizationsTariffes[explorerItem.id] &&
            organizationsTariffes[explorerItem.id].plan &&
            organizationsTariffes[explorerItem.id].status === "ACTIVE" ? (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/pricing");
                }}
                style={{
                  paddingTop: 2,
                  paddingBottom: 2,
                  paddingLeft: 5,
                  paddingRight: 5,
                  marginLeft: 10,
                  border: "1px solid #717B8E",
                  borderRadius: 5,
                  fontSize: 10,
                }}
              >
                {organizationsTariffes[explorerItem.id].plan.name}
              </div>
            ) : null}
          </div>
          {/* {isHovered && (explorerItem.isOrg || !!explorerItem.myRole) && ( */}
          {isHovered && (
            <div
              onMouseEnter={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(explorerItem.id)
              }
              onMouseLeave={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(null)
              }
              ref={dotsRef}
              onClick={(e) => onClickExplorerDots(explorerItem, e)}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                padding: "4px",
              }}
            >
              <VerticalDots
                style={{
                  color:
                    selectedItem && selectedItem.id === explorerItem.id
                      ? "#3496FF"
                      : hoveredDotsItemId === explorerItem.id
                        ? "#C1C7D4"
                        : "#717B8E",
                }}
                width={16}
                height={16}
              />
            </div>
          )}
        </div>
        {((!explorerItem.isRoot || isCurrentRoot) &&
          explorerItem.children &&
          explorerItem.isUnfolded &&
          Object.keys(explorerItem.children).length !== 0 &&
          Object.values(explorerItem.children).map((child, index) =>
            renderExplorerItem(
              child,
              activePadding + 17,
              index === Object.values(explorerItem.children).length - 1
            )
          )) ||
          null}
        {shareModalEntity &&
          (shareModalEntity.versionId === explorerItem.id ||
            shareModalEntity.project.id === explorerItem.id) && (
            <ShareModal
              isOpen={
                shareModalEntity &&
                shareModalEntity.versionId === explorerItem.id
              }
              versionId={isVersion ? explorerItem.id : null}
              project={{ id: isVersion ? null : explorerItem.id }}
              onClose={() => setShareModalEntity(null)}
              handleOpenBacklog={() => {}}
              handleChangeCover={() => {}}
              handleRenameProject={() => {}}
              handleDeleteProject={() => {}}
              handleArchiveProject={() => {}}
            />
          )}
      </>
    );
  };

  if (isPageLoading) {
    return (
      <div
        className={
          isMobile ? "projectExplorer-dummy-mobile" : "projectExplorer-dummy"
        }
      >
        {(isMobile && (
          <OrbitProgress style={{ fontSize: 8 }} color="white" />
        )) ||
          null}
      </div>
    );
  }

  const handleOrgItemContextMenuAction = (action) => {
    const selectedOrg = organizations.find((org) => org.id === selectedItem.id);
    if (action === "rename") {
      setOrganizationToRename(selectedOrg);
    } else if (action === "delete") {
      handleDeleteOrg(selectedOrg);
    }

    setShowOrgItemContextMenu(false);
  };

  const handleRenameAction = (e) => {
    handleOrgItemContextMenuAction("rename");
  };

  const handleDeleteOrg = (selectedOrg) => {
    if (organizations.length === 1) {
      alert("Вы не можете удалить последнюю организацию!");
    }
    if (window.confirm(t("projectScreen.confirmDeleteOrg"))) {
      dispatch(deleteOrganization(selectedOrg.id)).then((res) => {
        if (!res.error) {
          if (currentOrganization.id === selectedOrg.id) {
            onOrganizationSelect(organizations[0]);
          }
        }
      });
      setShowOrgItemContextMenu(false);
    }
  };

  const handleLeaveOrganization = async (e) => {
    if (
      window.confirm(
        "Вы уверены, что хотите покинуть рабочее пространство?\nВсе проекты и видео из него станут вам недоступны."
      )
    ) {
      const selectedOrg = organizations.find(
        (org) => org.id === selectedItem.id
      );
      const userRolesRes = await dispatch(
        fetchUserProjectRoles({
          organizationId: selectedOrg.id,
          userId: user.userId,
        })
      );
      for (let i = 0; i < userRolesRes.payload.length; i++) {
        const userRole = userRolesRes.payload[i];
        await dispatch(deleteUserProjectRole({ roleId: userRole.id }));
      }
      onOrganizationSelect(organizations[0]);
      dispatch(removeOrganizationFromStructure(selectedItem.id));
      setShowOrgItemContextMenu(false);
    }
  };

  return (
    <div
      className={isMobile ? "projectExplorer-mobile" : "projectExplorer"}
      style={{
        opacity: showArchived ? 0.5 : 1,
        pointerEvents: showArchived ? "none" : "auto",
      }}
    >
      {!isShared && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            height: 20,
            marginBottom: 10,
            cursor: "pointer",
            width: "100%",
          }}
          onClick={() => {
            if (organizationsTariffes[currentOrganization.id].plan) {
              setIsOrganizationLimitModalVisible(true);
            } else {
              onAddOrganization();
            }
          }}
          onMouseEnter={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            setTitleHovered(true)
          }
          onMouseLeave={() =>
            !showProjectContextMenu &&
            !showVersionContextMenu &&
            !selectedItem &&
            setTitleHovered(false)
          }
        >
          <span
            className="projectExplorer-title"
            style={{ color: titleHovered ? "#C1C7D4" : "#717b8e" }}
          >
            Рабочие пространства
          </span>
          <div
            style={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              justifyContent: "flex-end",
            }}
          >
            <span
              style={{
                color: titleHovered ? "#C1C7D4" : "#717b8e",
                fontSize: 26,
              }}
            >
              +
            </span>
          </div>
        </div>
      )}
      <div className="projectExplorer-projects-tree">
        {!isPageLoading ? (
          Object.values(currentProjectsStructure).map((explorerItem) =>
            renderExplorerItem(explorerItem)
          )
        ) : (
          <OrbitProgress style={{ fontSize: 8 }} color="white" />
        )}
      </div>
      {!!sharedProjectsStructure &&
        !!Object.keys(sharedProjectsStructure).length && (
          <>
            <span
              className="projectExplorer-title"
              style={{ marginTop: isShared ? 0 : 20, marginBottom: 5 }}
            >
              Доступные мне
            </span>
            <div className="projectExplorer-projects-tree">
              {!isPageLoading
                ? Object.values(sharedProjectsStructure).map((explorerItem) =>
                    renderSharedExplorerItem(explorerItem)
                  )
                : null}
            </div>
          </>
        )}
      {showProjectContextMenu && selectedItem && (
        <ProjectContextMenu
          ref={projectContextMenuRef}
          isShared={selectedItem.isShared}
          onRemoveFromShared={(e) =>
            handleRemoveProjectFromShared(e, selectedItem)
          }
          onOpenShare={() => {
            setShareModalEntity({
              versionId: null,
              project: { id: selectedItem.id },
            });
          }}
          projectId={selectedItem.id}
          posterUrl={selectedItem.posterUrl}
          onArchive={(e) => handleArchiveProject(selectedItem.id, e)}
          isArchive={selectedItem.isArchive}
          onDelete={(e) => handleDeleteProject(selectedItem.id, e)}
          onRename={(e) => handleRenameProject(e, selectedItem.id)}
          onChangeCover={(e) => handleChangeCover(e, selectedItem.id)}
          onClose={() => {
            setSelectedItem(null);

            setShowProjectContextMenu(false);
          }}
          usePortal={true}
          style={{
            position: "absolute",
            top: contextMenuPosition.top,
            left: contextMenuPosition.left,
            zIndex: 2000,
          }}
        />
      )}
      {showVersionContextMenu && selectedItem && (
        <VersionContextMenu
          ref={versionContextMenuRef}
          versionId={selectedItem.id}
          isShared={selectedItem.isShared}
          onOpenShare={() => {
            setShareModalEntity({
              versionId: selectedItem.id,
              project: { id: null },
            });
          }}
          onRename={(e) => handleRenameVersion(e, selectedItem.id)}
          onArchive={(e) => handleArchiveVersion(e, selectedItem.id)}
          onDelete={(e) => handleDeleteVersion(e, selectedItem.id)}
          onRemoveFromShared={(e) =>
            handleRemoveProjectFromShared(e, selectedItem.id)
          }
          isArchive={selectedItem.isArchive}
          onClose={() => {
            setSelectedItem(null);
            setShowVersionContextMenu(false);
          }}
          usePortal={true}
          style={{
            position: "absolute",
            top: contextMenuPosition.top,
            left: contextMenuPosition.left,
            zIndex: 2000,
          }}
        />
      )}

      {showOrgItemContextMenu && selectedItem && (
        <OrganizationItemContextMenu
          ref={orgItemContextMenuRef}
          organization={selectedItem}
          onRename={handleRenameAction}
          onLeave={(e) => handleLeaveOrganization(e)}
          onDelete={(e) => handleOrgItemContextMenuAction("delete")}
          onOpenTeamScreen={() => {
            setOrgToShowUsersPopup(selectedItem);
            setSelectedItem(null);
          }}
          onClose={() => setShowOrgItemContextMenu(false)}
          usePortal={false}
          style={{
            position: "fixed",
            top: contextMenuPosition.top,
            left: contextMenuPosition.left,
            zIndex: 10000,
          }}
        />
      )}
      {projectToRename && (
        <EditProjectModal
          project={projectToRename}
          onRenamed={(updatedProject) => {
            updateProjectInProjectsStructure(updatedProject);
            setProjectToRename(null);
          }}
          onClose={() => setProjectToRename(null)}
        />
      )}
      {projectToChangeCover && (
        <EditProjectPosterModal
          fetchCurrentProjectById={() => {}}
          project={projectToChangeCover}
          onPosterUpdated={(updatedProject) => {
            updateProjectInProjectsStructure(updatedProject);
          }}
          onClose={() => setProjectToChangeCover(null)}
        />
      )}
      {versionToRename && (
        <EditVersionModal
          fetchCurrentProjectById={
            () => {}
            //fetchCurrentProjectById(currentProject.id)
          }
          currentProject={currentProject}
          version={{
            versionId: versionToRename.id,
            version: versionToRename.title,
          }}
          onClose={() => setVersionToRename(null)}
          onRenamed={(updatedVersion) => {
            updateVersionInProjectsStructure(updatedVersion);
            setVersionToRename(null);
          }}
        />
      )}
      {organizationToRename && (
        <EditOrganizationModal
          organization={organizationToRename}
          onClose={() => setOrganizationToRename(null)}
          onSave={(updatedOrg) => {
            // Update organizations list in parent component
            // For now, just close the modal
            setOrganizationToRename(null);
          }}
        />
      )}
      {orgToShowUsersPopup && (
        <OrgUsersPopup
          orgInfo={orgToShowUsersPopup}
          isOpen={orgToShowUsersPopup}
          onClose={() => setOrgToShowUsersPopup(null)}
        />
      )}
      {isOrganizationLimitModalVisible && (
        <InfoModal
          actionText={"Перейти к тарифам"}
          action={() => {
            navigate("/pricing");
          }}
          title="Тарифный план исчерпан"
          text="Обновитесь на один из доступных тарифов, чтобы создавать больше организаций"
          isOpen={isOrganizationLimitModalVisible}
          onClose={() => setIsOrganizationLimitModalVisible(false)}
        />
      )}
      {limitsValues && myOrgRole && myOrgRole.role === "OWNER" && (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            justifySelf: "flex-end",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            paddingLeft: 15,
            paddingBottom: 15,
          }}
        >
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: "rgb(193, 199, 212)",
            }}
          >
            Лимиты:
          </span>
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: "rgb(193, 199, 212)",
            }}
          >
            {`Проекты: ${limitsValues.projectsCurrent}/${limitsValues.projectsMax}`}
          </span>
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: "rgb(193, 199, 212)",
            }}
          >
            {`Пользователи: ${limitsValues.usersCurrent}/${limitsValues.usersMax}`}
          </span>
          <span
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: "rgb(193, 199, 212)",
            }}
          >
            {`Место на диске (Мб): ${limitsValues.spaceCurrent}/${limitsValues.spaceMax}`}
          </span>
        </div>
      )}
    </div>
  );
}

export default ProjectExplorer;
